export const LATINS_NUMBERS = /^[a-zA-Z0-9\s,-/]+$/
